import alaffiaLogoData from "./assets/alaffiaLogo.png";

export function AlaffiaLogo() {
  return (
    <img
      src={alaffiaLogoData}
      alt="Alaffia Logo"
      className="af-max-w-8"
      width={32}
      height={32}
    />
  );
}
